import Model, { attr, belongsTo } from "@ember-data/model";
import { tKey } from "ember-intl";

export default class VpnUserModel extends Model {
  @attr username;
  @attr protocol;
  @attr("yesno") enabled;
  @attr password;

  @belongsTo("project", { async: false, inverse: "vpnUsers" }) project;

  get status() {
    return this.enabled
      ? { state: "online", labelKey: tKey("vpn.enable") }
      : { state: "offline", labelKey: tKey("vpn.disable") };
  }
}
